import { getDeviceIdFromLocalStorage } from '../../utils/getlb-user-id'
import { quinceTrustAndSafetyServiceHttpClient } from '../../utils/HttpClient'

import { GenerateOtpAPIResponse } from './trustAndSafety.types'

class TrustAndSafetyService {
  async generateDeviceId(_email: string): Promise<string> {
    const { data } = await quinceTrustAndSafetyServiceHttpClient.post(`/trust-safety-service/device`, {})
    return data
  }
  async generateOtp(verificationResource: string): Promise<GenerateOtpAPIResponse> {
    const deviceId = getDeviceIdFromLocalStorage()
    const { data } = await quinceTrustAndSafetyServiceHttpClient.post(
      `/trust-safety-service/customer-device-authorization`,
      {
        resourceId: verificationResource,
        resourceType: 'CUSTOMER',
        userAction: 'FIND_ORDER',
        authenticationMode: 'OTP',
      },
      {
        headers: {
          'x-device-id': deviceId,
        },
      },
    )
    return data
  }
  async submitOtp(otp: string, otpRequestId: string, verificationResource: string): Promise<GenerateOtpAPIResponse> {
    const deviceId = getDeviceIdFromLocalStorage()
    const { data } = await quinceTrustAndSafetyServiceHttpClient.put(
      `/trust-safety-service/customer-device-authorization/validate`,
      {
        resourceId: verificationResource,
        resourceType: 'CUSTOMER',
        userAction: 'FIND_ORDER',
        authenticationMode: 'OTP',
        customerAuthorizationDetails: {
          code: otp,
          otpRequestId,
        },
      },
      {
        headers: {
          'x-device-id': deviceId,
        },
      },
    )
    return data
  }
  async resendOtp(verificationResource: string): Promise<GenerateOtpAPIResponse> {
    const deviceId = getDeviceIdFromLocalStorage()
    const { data } = await quinceTrustAndSafetyServiceHttpClient.post(
      `/trust-safety-service/customer-device-authorization/resend`,
      {
        resourceId: verificationResource,
        resourceType: 'CUSTOMER',
        userAction: 'FIND_ORDER',
      },
      {
        headers: {
          'x-device-id': deviceId,
        },
      },
    )
    return data
  }
}

const trustAndSafetyService = new TrustAndSafetyService()

export default trustAndSafetyService
